import React from 'react';
import styled, { css } from 'styled-components';
import SDGIcon1 from '../../assets/rice.png';
import SDGIcon2 from '../../assets/foodwaste.jpg';
import SDGIcon3 from '../../assets/cg-128.jpg';
import SDG1 from '../../assets/2.png';
import SDG2 from '../../assets/12.png';
import SDG3 from '../../assets/13.png';

const glass = css`
  backdrop-filter: blur(14px) saturate(180%);
  -webkit-backdrop-filter: blur(14px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.22);
`;

const SdgSection = () => {
  return (
    <SDGSectionContainer>
      <SDGIconContainer bgImage={SDGIcon1} reverse={false}>
        <SDGLogoContainer reverse={false}>
          <Logo src={SDG1} alt="SDG Goal 2" />
        </SDGLogoContainer>
        <SDGText>
          <h3>Goal 2: Zero Hunger</h3>
          <p>
            Zero Hunger aims to end hunger, achieve food security, and improve nutrition while promoting sustainable
            agriculture. By ensuring everyone has access to safe, nutritious, and sufficient food year-round, we can
            foster a healthier, more equitable world.
          </p>
        </SDGText>
      </SDGIconContainer>

      <SDGIconContainer bgImage={SDGIcon2} reverse>
        <SDGLogoContainer reverse>
          <Logo src={SDG2} alt="SDG Goal 12" />
        </SDGLogoContainer>
        <SDGText>
          <h3>Goal 12: Responsible Consumption</h3>
          <p>
            This goal emphasizes reducing waste and ensuring sustainable patterns of production and consumption. By
            improving resource efficiency and minimizing environmental impact, we can secure a more sustainable future
            for generations to come.
          </p>
        </SDGText>
      </SDGIconContainer>

      <SDGIconContainer bgImage={SDGIcon3} reverse={false}>
        <SDGLogoContainer reverse={false}>
          <Logo src={SDG3} alt="SDG Goal 13" />
        </SDGLogoContainer>
        <SDGText>
          <h3>Goal 13: Climate Action</h3>
          <p>
            Climate Action focuses on taking urgent measures to combat climate change and its impacts. By addressing
            global warming and fostering resilience against climate-related hazards, we aim to protect our planet and
            its ecosystems.
          </p>
        </SDGText>
      </SDGIconContainer>
    </SDGSectionContainer>
  );
};

export default SdgSection;

const Logo = styled.img`
  height: 260px;
  width: auto;
  transition: transform 0.25s ease, filter 0.25s ease;

  &:hover {
    transform: scale(1.06);
    filter: brightness(1.08);
  }

  @media (max-width: 768px) {
    height: 210px;
  }
`;

const SDGSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  margin-top: 2rem;
  padding: 1rem;
  width: 100%;
`;

const SDGIconContainer = styled.div`
  width: min(1200px, 94vw);
  display: flex;
  align-items: center;
  gap: 1.6rem;
  padding: 1.6rem;
  border-radius: 18px;
  overflow: hidden;
  position: relative;

  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  background-position: center;

  /* Glassy veil over image */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.28);
    ${glass}
    z-index: 0;
  }

  /* Content above overlay */
  & > * {
    position: relative;
    z-index: 1;
  }

  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 16px 55px rgba(0, 0, 0, 0.22);
  transition: transform 0.22s ease, box-shadow 0.22s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1.1rem;
  }

  ${(props) =>
    props.reverse &&
    `
    flex-direction: row-reverse;
    @media (max-width: 768px) {
      flex-direction: column;
    }
  `}
`;

const SDGLogoContainer = styled.div`
  width: ${(props) => (props.reverse ? '240px' : '320px')};
  height: ${(props) => (props.reverse ? '240px' : '320px')};
  border-radius: 16px;
  overflow: hidden;
  display: grid;
  place-items: center;

  ${glass}
  background: rgba(255, 255, 255, 0.10);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const SDGText = styled.div`
  max-width: 680px;
  padding: 1.35rem 1.35rem;
  border-radius: 16px;

  ${glass}
  background: rgba(255, 255, 255, 0.10);

  h3 {
    margin: 0 0 0.65rem;
    font-size: clamp(1.8rem, 2.6vw, 2.7rem);
    font-weight: 900;
    color: rgba(255, 255, 255, 0.96);
    text-shadow: 0 12px 26px rgba(0, 0, 0, 0.35);
  }

  p {
    margin: 0;
    font-size: 1rem;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.90);
    font-family: 'Poppins', sans-serif;
  }

  @media (max-width: 768px) {
    padding: 1.1rem;
  }
`;
